import { Options, Vue } from 'vue-class-component'
import Chart from 'chart.js'
import { Http, Urls } from '../../module/http'
import { ResDetailCompare, ResDetailSales, ResponseData } from '@/module/response'
import DatePicker from 'tui-date-picker'
import 'tui-date-picker/dist/tui-date-picker.css'
import { DateRes, Tool } from '@/module/tool'

@Options({
  props: ['chartIds', 'chartCode', 'chartAttr'],
  components: { DatePicker },
  emits: {
    click: null,
    closechart: () => {
      return true
    },
    showmessage: () => {
      return true
    }
  },
  watch: {
    chartIds () {
      if (this.$props.chartIds.length < 1) {
        return
      }
      this.initData()
      this.setChartLineRangeDate()
      this.setChartBarRangeDate()
    }
  }
})

export default class SalesChart extends Vue {
    chartBarData: ResDetailCompare | null = null

    statisticsByDay = true
    statisticsByWeek = false
    statisticsByMonth = false

    statisticsByWeekStop = false
    statisticsByMonthStop = false

    chartLineLabels: string[] = []
    chartLineTmallData: number[] = []
    chartLineJdData: number[] = []
    chartLineCountData: number[] = []

    initRes: ResDetailSales | null = null
    initChartLineLabels: string[] = []
    initChartLineTmallData: number[] = []
    initChartLineJdData: number[] = []
    initChartLineCountData: number[] = []

    lineStartDate: Date = new Date(new Date().setDate(new Date().getDate() - 30))
    lineEndDate: Date = new Date()
    BarStartDate: Date = new Date(new Date().setDate(new Date().getDate() - 30))
    BarEndDate: Date = new Date()

    lineChart: Chart | null = null
    barChart: Chart | null = null

    initData () {
      this.getChartLineData(this.lineStartDate, this.lineEndDate)
      this.getChartBarData(this.BarStartDate, this.BarEndDate)
    }

    getChartLineData (start: Date, end: Date) {
      this.lineStartDate = start
      this.lineEndDate = end
      this.statisticsByDay = true
      this.statisticsByWeek = false
      this.statisticsByMonth = false
      // 判断日期 按日 如果开始日期和结束日期为当天 直接返回拼接值
      const now = Tool.dateFormat(new Date())
      const s = Tool.dateFormat(start)
      if (this.statisticsByDay && now === s) {
        this.chartLineLabels = [now]
        this.chartLineCountData = [0]
        this.chartLineTmallData = [0]
        this.chartLineJdData = [0]
        this.initRes = null
        this.initChartLineLabels = this.chartLineLabels
        this.initChartLineTmallData = this.chartLineCountData
        this.initChartLineJdData = this.chartLineTmallData
        this.initChartLineCountData = this.chartLineJdData
        this.chartLine()
        return
      }
      const data = {
        devicesId: this.$props.chartIds,
        start: start,
        end: end
      }
      Http.post<ResDetailSales>(Urls.detail_sales, data).then((res: ResDetailSales) => {
        if (res) {
          this.chartLineLabels = res['2'] !== undefined ? Object.keys(res['2']) : []
          this.chartLineCountData = res['0'] !== undefined ? Object.values(res['0']) : []
          this.chartLineTmallData = res['2'] !== undefined ? Object.values(res['2']) : []
          this.chartLineJdData = res['3'] !== undefined ? Object.values(res['3']) : []
          this.initRes = res
          this.initChartLineLabels = this.chartLineLabels
          this.initChartLineTmallData = this.chartLineTmallData
          this.initChartLineJdData = this.chartLineJdData
          this.initChartLineCountData = this.chartLineCountData
          this.chartLine()
        } else {
          this.handleNotData(start, end)
        }
      }, (err: ResponseData) => {
        this.$emit('showmessage', err.Msg)
      })
    }

    handleNotData (start: Date, end: Date) {
      const day = Tool.countingDays(start, end)
      const rangeDate = Tool.getRangeDate(day, start)
      const num: Array<number> = []
      for (let i = 1; i <= day; i++) {
        num.push(0)
      }
      this.chartLineLabels = rangeDate
      this.chartLineCountData = num
      this.chartLineTmallData = num
      this.chartLineJdData = num
      this.initRes = null
      this.initChartLineLabels = this.chartLineLabels
      this.initChartLineTmallData = this.chartLineCountData
      this.initChartLineJdData = this.chartLineTmallData
      this.initChartLineCountData = this.chartLineJdData
      this.chartLine()
    }

    getChartBarData (start: Date, end: Date) {
      const data = {
        devicesId: this.$props.chartIds,
        start: start,
        end: end
      }
      Http.post<ResDetailCompare>(Urls.detail_compare, data).then((res: ResDetailCompare) => {
        this.chartBarData = res
        this.chartBar()
      }, (err: ResponseData) => {
        this.$emit('showmessage', err.Msg)
      })
    }

    switchStatistics (s: string) {
      switch (s) {
        case 'day':
          this.statisticsByDay = true
          this.statisticsByWeek = false
          this.statisticsByMonth = false
          this.chartLineLabels = this.initChartLineLabels
          this.chartLineTmallData = this.initChartLineTmallData
          this.chartLineJdData = this.initChartLineJdData
          this.chartLineCountData = this.initChartLineCountData
          this.chartLine()
          return
        case 'week':
          this.statisticsByDay = false
          this.statisticsByWeek = true
          this.statisticsByMonth = false
          this.handleWeekRes()
          this.chartLine()
          return
        case 'month':
          this.statisticsByDay = false
          this.statisticsByWeek = false
          this.statisticsByMonth = true
          this.handleMonthRes()
          this.chartLine()
      }
    }

    handleWeekRes () {
      const data = this.initRes
      if (data) {
        const dateRes: DateRes[] = Tool.getDateRes(this.lineStartDate, this.lineEndDate)
        this.chartLineLabels = []
        this.chartLineCountData = []
        this.chartLineTmallData = []
        this.chartLineJdData = []
        for (let i = 0; i <= dateRes.length - 1; i++) {
          this.chartLineLabels.push(dateRes[i].dateRange)
          const dateArray = Object.values(dateRes[i].dateArray)
          let num0 = 0
          let num2 = 0
          let num3 = 0
          for (let i = 0; i <= dateArray.length - 1; i++) {
            const dateFlag = dateArray[i]
            if (data['0']) {
              const kv = data['0']
              for (const k in kv) {
                if (dateFlag === k) {
                  num0 += kv[k]
                }
              }
            }
            if (data['2']) {
              const kv = data['2']
              for (const k in kv) {
                if (dateFlag === k) {
                  num2 += kv[k]
                }
              }
            }
            if (data['3']) {
              const kv = data['3']
              for (const k in kv) {
                if (dateFlag === k) {
                  num3 += kv[k]
                }
              }
            }
          }
          this.chartLineCountData.push(num0)
          this.chartLineTmallData.push(num2)
          this.chartLineJdData.push(num3)
        }
        return
      }
      this.statisticsByDay = true
      this.statisticsByWeek = false
      this.statisticsByMonth = false
      this.chartLineLabels = this.initChartLineLabels
      this.chartLineTmallData = this.initChartLineTmallData
      this.chartLineJdData = this.initChartLineJdData
      this.chartLineCountData = this.initChartLineCountData
    }

    handleMonthRes () {
      const data = this.initRes
      if (data) {
        const mothRes: DateRes[] = Tool.getMonthDateRes(this.lineStartDate, this.lineEndDate)
        this.chartLineLabels = []
        this.chartLineCountData = []
        this.chartLineTmallData = []
        this.chartLineJdData = []
        for (let i = 0; i <= mothRes.length - 1; i++) {
          this.chartLineLabels.push(mothRes[i].dateRange)
          const dateArray = Object.values(mothRes[i].dateArray)
          let num0 = 0
          let num2 = 0
          let num3 = 0
          for (let i = 0; i <= dateArray.length - 1; i++) {
            const dateFlag = dateArray[i]
            if (data['0']) {
              const kv = data['0']
              for (const k in kv) {
                if (dateFlag === k) {
                  num0 += kv[k]
                }
              }
            }
            if (data['2']) {
              const kv = data['2']
              for (const k in kv) {
                if (dateFlag === k) {
                  num2 += kv[k]
                }
              }
            }
            if (data['3']) {
              const kv = data['3']
              for (const k in kv) {
                if (dateFlag === k) {
                  num3 += kv[k]
                }
              }
            }
          }
          this.chartLineCountData.push(num0)
          this.chartLineTmallData.push(num2)
          this.chartLineJdData.push(num3)
        }
        return
      }
      this.statisticsByDay = true
      this.statisticsByWeek = false
      this.statisticsByMonth = false
      this.chartLineLabels = this.initChartLineLabels
      this.chartLineTmallData = this.initChartLineTmallData
      this.chartLineJdData = this.initChartLineJdData
      this.chartLineCountData = this.initChartLineCountData
    }

    chartLine () {
      if (this.lineChart !== null) {
        this.lineChart.data.datasets = []
        this.lineChart.update()
      }
      const el = document.getElementById('chart_line') as HTMLCanvasElement
      const ctx = el.getContext('2d') as CanvasRenderingContext2D
      const opt: Chart.ChartConfiguration = {
        type: 'line',
        data: {
          labels: this.chartLineLabels,
          datasets: [{
            // label: '天猫销量',
            label: this.$i18n.t('tmSales'),
            borderColor: 'rgba(91, 138, 252, 1)',
            backgroundColor: 'rgba(91, 138, 252, 1)',
            fill: false,
            data: this.chartLineTmallData
          }, {
            // label: '京东销量',
            label: this.$i18n.t('jdSales'),
            borderColor: 'rgba(255, 117, 64, 1)',
            backgroundColor: 'rgba(255, 117, 64, 1)',
            fill: false,
            data: this.chartLineJdData
          }, {
            // label: '总销量',
            label: this.$i18n.t('countSales'),
            borderColor: 'rgba(251, 36, 36, 1)',
            backgroundColor: 'rgba(251, 36, 36, 1)',
            fill: false,
            data: this.chartLineCountData
          }]
        },
        options: {
          responsive: true,
          tooltips: {
            mode: 'index',
            intersect: false
          },
          scales: {
            yAxes: [{
              display: true,
              ticks: {
                stepSize: 5
              }
            }]
          }
        }
      }
      this.lineChart = new Chart(ctx, opt)
    }

    chartBar () {
      if (this.barChart !== null) {
        this.barChart.data.datasets = []
        this.barChart.update()
      }
      const el = document.getElementById('chart_bar') as HTMLCanvasElement
      const ctx = el.getContext('2d') as CanvasRenderingContext2D
      const opt: Chart.ChartConfiguration = {
        type: 'bar',
        data: {
          // labels: ['本期', '同比', '环比'],
          // labels: [
          //   this.$i18n.t('now'),
          //   this.$i18n.t('yoy'),
          //   this.$i18n.t('mom')
          // ],
          // labels: ['总销量', '天猫销量', '京东销量'],
          labels: [
            this.$i18n.t('countSales'),
            this.$i18n.t('tmSales'),
            this.$i18n.t('jdSales')
          ],
          datasets: [{
            // label: '天猫销量',
            // label: this.$i18n.t('tmSales'),
            // label: '本期',
            label: this.$i18n.t('now'),
            borderColor: 'rgba(91, 138, 252, 1)',
            backgroundColor: 'rgba(91, 138, 252, 1)',
            fill: false,
            // data: [this.chartBarData?.Now['2'], this.chartBarData?.YoY['2'], this.chartBarData?.MoM['2']]
            data: [this.chartBarData?.All['Now'], this.chartBarData?.Jd['Now'], this.chartBarData?.Tm['Now']]
          }, {
            // label: '京东销量',
            // label: this.$i18n.t('jdSales'),
            // label: '同比',
            label: this.$i18n.t('yoy'),
            borderColor: 'rgba(255, 117, 64, 1)',
            backgroundColor: 'rgba(255, 117, 64, 1)',
            fill: false,
            // data: [this.chartBarData?.Now['3'], this.chartBarData?.YoY['3'], this.chartBarData?.MoM['3']]
            data: [this.chartBarData?.All['YoY'], this.chartBarData?.Jd['YoY'], this.chartBarData?.Tm['YoY']]
          }, {
            // label: '总销量',
            // label: this.$i18n.t('countSales'),
            // label: '环比',
            label: this.$i18n.t('mom'),
            borderColor: 'rgba(251, 36, 36, 1)',
            backgroundColor: 'rgba(251, 36, 36, 1)',
            fill: false,
            // data: [this.chartBarData?.Now['0'], this.chartBarData?.YoY['0'], this.chartBarData?.MoM['0']]
            data: [this.chartBarData?.All['MoM'], this.chartBarData?.Jd['MoM'], this.chartBarData?.Tm['MoM']]
          }]

        },
        options: {
          responsive: true,
          tooltips: {
            mode: 'index',
            intersect: false
          }
        }
      }
      this.barChart = new Chart(ctx, opt)
    }

    setChartLineRangeDate () {
      const lineStartPickerInput = document.getElementById(
        'chart_line_start_picker_input'
      ) as HTMLInputElement
      const lineStartPickerContainer = document.getElementById(
        'chart_line_start_picker_container'
      ) as HTMLElement

      const lineEndPickerInput = document.getElementById(
        'chart_line_end_picker_input'
      ) as HTMLInputElement
      const lineEndPickerContainer = document.getElementById(
        'chart_line_end_picker_container'
      ) as HTMLElement

      const datePicker = DatePicker.createRangePicker({
        language: 'Chinese character',
        startpicker: {
          date: this.lineStartDate,
          input: lineStartPickerInput,
          container: lineStartPickerContainer
        },
        endpicker: {
          date: this.lineEndDate,
          input: lineEndPickerInput,
          container: lineEndPickerContainer
        }
      })

      datePicker.on('change:end', () => {
        this.getChartLineData(datePicker.getStartDate(), datePicker.getEndDate())
      })

      datePicker.on('change:start', () => {
        this.getChartLineData(datePicker.getStartDate(), datePicker.getEndDate())
      })
    }

    setChartBarRangeDate () {
      const barStartPickerInput = document.getElementById(
        'chart_bar_start_picker_input'
      ) as HTMLInputElement
      const barStartPickerContainer = document.getElementById(
        'chart_bar_start_picker_container'
      ) as HTMLElement

      const barEndPickerInput = document.getElementById(
        'chart_bar_end_picker_input'
      ) as HTMLInputElement
      const barEndPickerContainer = document.getElementById(
        'chart_bar_end_picker_container'
      ) as HTMLElement

      const datePicker = DatePicker.createRangePicker({
        language: 'Chinese character',
        type: 'month',
        format: 'yyyy-MM',
        startpicker: {
          date: this.BarStartDate,
          input: barStartPickerInput,
          container: barStartPickerContainer
        },
        endpicker: {
          date: this.BarEndDate,
          input: barEndPickerInput,
          container: barEndPickerContainer
        }
      })
      datePicker.on('change:end', () => {
        this.getChartBarData(datePicker.getStartDate(), datePicker.getEndDate())
      })
      datePicker.on('change:start', () => {
        this.getChartBarData(datePicker.getStartDate(), datePicker.getEndDate())
      })
    }
}
